// extracted by mini-css-extract-plugin
export default {"container":"OrganizationEditOrganism_container__nMxUg","imageContainer":"OrganizationEditOrganism_imageContainer__OfbF7"};